<template>
  <div id="presale-container">
    <div class="row">
      <div class="col-sm-12">
        <p class="title">{{$t("events.presale.title")}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-2"></div>
      <div class="col-sm-8">
        <div class="row countdown">
          <div class="col-sm-12">
            <flip-clock id="pre-order-countdown" :options="flipOptions" />
          </div>
        </div>
      </div>
      <div class="col-sm-2"></div>
    </div>
    <div class="row mb-10">
      <div class="col-sm-12 total-order text-center">
        <label>{{$t("events.presale.total")}}</label>
        <span>
          {{totalPrice | toCurrency}}
        </span>
        <i class="fa fa-info-circle" :title="event.album_concept"></i>
      </div>
      <div class="col-sm-12">
        <button class="primary-btn-light" @click="addToCart()">
          {{$t("events.presale.buy")}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { FlipClock } from '@mvpleung/flipclock'
import ShoppingCart from "../../models/ShoppingCart"

export default {
  name: "Event.Presale",
  props:    {
    event: Object
  },
  data() {
    return {
      shoppingCart: new ShoppingCart()
    }
  },
  components: {
    FlipClock
  },
  computed: {
    flipOptions() {
      return {
        digit: parseInt(this.event.countdown),
        countdown: true,
        autoStart: true,
        language: 'es',
        clockFace: 'DailyCounter',
        callbacks: {
          stop: function() {
            //location.href = '/events/' + $("#event_id").val();
          }
        }
      }
    },
    totalPrice() {
      let price = this.event.pre_order_item.discount_price
      /*
      if(this.event.tax > 0) {
        return  (price * (this.event.tax / 100)) + price
      } else {
        return price
      }*/
      return price
    }
  },
  methods: {
    async addToCart() {
      const params = {event_id: this.event.identifier, photo_id: null}
      this.$alertify.success(this.$t("checkout.addedItem"))
      let add = await this.shoppingCart.addItem(params)
      this.$root.$emit("addItemToCart", params)
    }
  }
}
</script>

<style lang="scss">
  @import '../../scss/variables';

  #presale-container {
    .title {
      text-align: center;
      font-weight: bolder;
      font-size: 17px;
    }
  }

  .total-order {
    font-size: 20px;

    label {
      color: #000;
    }
    span{
      font-weight: bolder;
      font-size: 24px;
      color: #000;
    }
  }

  .flip-clock-wrapper {
    padding-left: 0;
    margin-bottom: 0 !important;

    ul {
      width: 25px;
      height: 45px;
      padding: 10px 18px;

      li {
        line-height: 45px;
        a div div.inn {
          font-size: 20px;
          background-color: #000;
        }
      }
    }
    .flip-clock-label {
      font-size: 14px;
      font-weight: bolder;
      color: #515151;
    }

    .flip-clock-divider.seconds .flip-clock-label {
      right: -78px;
    }

    .flip-clock-divider.minutes .flip-clock-label {
      right: -75px;
    }

    .flip-clock-divider.hours .flip-clock-label {
      right: -67px;
    }

    .flip-clock-divider.days .flip-clock-label {
      right: -63px;
    }
  }

  .flip-clock-dot.top {
    top: 13px;
  }

  .flip-clock-dot.bottom {
    bottom: 20px;
  }

  .flip-clock-divider {
    height: 60px;
  }

  @media screen and (max-width: 767px) {
    .flip-clock-wrapper {
      ul {
        width: 15px;
        height: 28px;
        margin: 1px;
        padding: 10px 13px;
        li {
          line-height: 28px;
          a div div.inn { font-size: 14px; }
        }
      }

      .flip-clock-divider.days .flip-clock-label {
        right: -44px !important;
      }

      .flip-clock-divider.hours .flip-clock-label {
        right: -45px !important;
      }

      .flip-clock-divider.minutes .flip-clock-label {
        right: -53px !important;
      }

      .flip-clock-divider.seconds .flip-clock-label {
        right: -60px !important;
      }
    }

    .flip-clock-label {
      font-size: 12px !important;
      right: -60px !important;
    }

    .flip-clock-dot.top {
      top: 7px !important;
      width: 7px !important;
      height: 7px !important;
    }

    .flip-clock-dot.bottom {
      bottom: 24px !important;
      width: 7px !important;
      height: 7px !important;
    }

    .flip-clock-divider { height: 50px !important; }
  }
</style>
